(function ($) {
    "use strict";
    $(function () {
        let $actionDetailModal = $(document).find('#actionDetailModal');
        if ($actionDetailModal.length) {
            $(document).find('a[data-news-detail-url]').on('click', function () {
                let $this = $(this),
                    url = $this.attr('data-news-detail-url');

                if (url) {
                    $.ajax({
                        url: url,
                        success: function (response) {
                            $actionDetailModal.html(response).foundation('open');
                        }
                    });
                }
            });
        }
    })
})(jQuery);
